<template>
    <section>
        <Header :title="isLoading || !goodPractice ? 'Good Practice' : goodPractice.title"
                show-back-button></Header>
        <v-container>
            <v-breadcrumbs :items="breadcrumbs" class="px-0"></v-breadcrumbs>
            <p v-if="isLoading" class="text-center my-7">
                <v-icon large color="primary">fal fa-spinner-third fa-spin</v-icon>
            </p>
            <v-alert v-if="notFound" color="warning">
                <v-icon class="mr-3">fal fa-exclamation-triangle</v-icon>
                <span>De good practice kon niet worden gevonden.</span>
            </v-alert>
            <v-card
                class="good-practice-detail-card"
                elevation="0"
                v-if="goodPractice"
            >
                <v-card-text class="pa-0">
                    <h2 class="text-h4 mb-2 primary--text">
                        {{ goodPractice.title }}
                    </h2>
                    <p class="font-weight-medium mb-4">{{ goodPractice.projectGroup }}</p>
                    <v-divider class="my-4"></v-divider>
                    <p style="white-space: pre-line;">{{ goodPractice.description }}</p>
                    <div v-if="goodPractice.attachments && goodPractice.attachments.length > 0" class="mt-6">
                        <h3 class="text-h6 mb-3">Bijlagen</h3>
                        <ul class="list-unstyled">
                            <li v-for="attachment in goodPractice.attachments" :key="attachment.fileName" class="mb-2">
                                <a :href="attachmentUrl(attachment)" target="_blank">
                                    <v-icon small color="primary" class="mr-1">fal fa-file</v-icon>
                                    {{ attachment.fileName }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
    </section>
</template>

<script>
import Header from "@/components/layout/Header";
import {mapState} from "vuex";

export default {
    name: 'GoodPractice',
    components: {
        Header,
    },
    props: {
        uuid: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        isLoading: true,
        notFound: false,
        goodPractice: null,
        breadcrumbs: [
            {
                text: 'Dashboard',
                disabled: false,
                exact: true,
                to: {
                    name: 'Home'
                }
            },
            {
                text: 'Good Practices',
                disabled: false,
                exact: true,
                to: {
                    name: 'GoodPractices'
                }
            },
            {
                text: 'Good Practice',
                disabled: true
            },
        ],
    }),
    computed: {
        ...mapState({
            loadedGoodPractices: state => state.goodPractice.loadedGoodPractices,
        }),
    },
    methods: {
        attachmentUrl(attachment) {
            return attachment.url;
        },
    },
    mounted() {
        this.$store.dispatch('goodPractice/getGoodPractice', this.uuid)
            .then(goodPractice => {
                this.goodPractice = goodPractice;
            })
            .catch(e => {
                console.error(e);
                this.$store.dispatch('showSnackbar', {color: 'error', text: 'Good practice kon niet worden opgehaald'});
                const loadedGoodPractice = this.loadedGoodPractices.find(gp => gp.uuid === this.uuid);
                if (loadedGoodPractice) {
                    this.goodPractice = loadedGoodPractice;
                } else {
                    this.notFound = true;
                    this.isLoading = false;
                }
            })
            .finally(() => {
                if (this.goodPractice) {
                    this.isLoading = false;
                }
            });
    },
}
</script>
